import React, { useMemo } from 'react';
import Select from 'react-select';

const SecurityFilters = ({
    selectedSite,
    sites,
    sitesLoaded,
    onSiteSelect,
    dateFrom,
    dateTo,
    onDateChange,
    selectedFinancialWeek,
    financialWeeks,
    onFinancialWeekSelect
}) => {
    const customSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '42px',
            fontSize: '14px',
            borderColor: 'rgba(255,255,255,0.12)',
            backgroundColor: 'rgba(255,255,255,0.03)',
            borderRadius: '6px',
            boxShadow: 'none',
            '&:hover': { borderColor: 'rgba(255,255,255,0.25)' }
        }),
        singleValue: (base) => ({ ...base, color: 'white' }),
        placeholder: (base) => ({ ...base, color: 'rgba(255,255,255,0.78)' }),
        input: (base) => ({ ...base, color: 'white' }),
        menu: (base) => ({ ...base, zIndex: 9999, backgroundColor: '#1e163c', border: '1px solid rgba(255,255,255,0.12)' }),
        option: (base, state) => ({
            ...base,
            fontSize: '14px',
            backgroundColor: state.isSelected ? '#CB2C84' : state.isFocused ? 'rgba(0,93,229,0.1)' : 'transparent',
            color: 'white',
            '&:active': { backgroundColor: 'rgba(0,93,229,0.2)' }
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base) => ({ ...base, color: 'rgba(255,255,255,0.5)', '&:hover': { color: 'white' } }),
        clearIndicator: (base) => ({ ...base, color: 'rgba(255,255,255,0.5)', '&:hover': { color: 'white' } }),
    };

    const siteOptions = useMemo(() =>
        sites.map(site => ({
            value: site.venueID,
            label: site.site_name,
            data: site
        })),
        [sites]
    );

    const financialWeekOptions = useMemo(() =>
        financialWeeks.map(fw => ({
            value: fw.description,
            label: fw.description,
            data: fw
        })),
        [financialWeeks]
    );

    const selectedSiteOption = siteOptions.find(o => o.label === selectedSite) || null;
    const selectedFwOption = financialWeekOptions.find(o => o.value === selectedFinancialWeek?.description) || null;

    return (
        <>
            {(!sitesLoaded || sites?.length > 0) && (
                <div className="filter-item">
                    <label>Site</label>
                    <Select
                        value={selectedSiteOption}
                        onChange={(selected) => {
                            if (selected) {
                                const { data } = selected;
                                onSiteSelect(data.site_name, data.venueID, data.codb, data.bun);
                            } else {
                                onSiteSelect('', '', '', '');
                            }
                        }}
                        options={siteOptions}
                        placeholder="Select"
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        styles={customSelectStyles}
                    />
                </div>
            )}

            <div className="date-filter-item">
                <label htmlFor="global-shift-date-from">From</label>
                <input
                    type="date"
                    className="form-control"
                    id="global-shift-date-from"
                    value={dateFrom || ''}
                    onChange={(event) => onDateChange('shiftStart', event.target.value)}
                />
            </div>

            <div className="date-filter-item">
                <label htmlFor="global-shift-date-to">To</label>
                <input
                    type="date"
                    className="form-control"
                    id="global-shift-date-to"
                    value={dateTo || ''}
                    onChange={(event) => onDateChange('shiftFinish', event.target.value)}
                />
            </div>

            <div className="filter-item">
                <label>Financial Week</label>
                <Select
                    value={selectedFwOption}
                    onChange={(selected) => {
                        onFinancialWeekSelect(selected ? selected.data : null);
                    }}
                    options={financialWeekOptions}
                    placeholder="Select"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    styles={{
                        ...customSelectStyles,
                        singleValue: (base) => ({ ...base, color: 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }),
                        option: (base, state) => ({
                            ...customSelectStyles.option(base, state),
                            whiteSpace: 'nowrap',
                        }),
                    }}
                />
            </div>
        </>
    );
};

export default SecurityFilters;
